import { isDevMode, ModuleWithProviders, NgModule } from '@angular/core';
import {
    DefaultFallbackStrategy,
    DefaultInterceptor,
    DefaultMissingHandler,
    DefaultTranspiler,
    TRANSLOCO_CONFIG,
    TRANSLOCO_FALLBACK_STRATEGY,
    TRANSLOCO_INTERCEPTOR,
    TRANSLOCO_MISSING_HANDLER,
    TRANSLOCO_SCOPE,
    TRANSLOCO_TRANSPILER,
    translocoConfig,
    TranslocoModule
} from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

import { availableLocales, defaultLocale } from './entities/config';

@NgModule({
    imports: [TranslocoModule],
    exports: [TranslocoModule]
})
export class I18nModule {
    static forRoot(): ModuleWithProviders<I18nModule> {
        return {
            ngModule: I18nModule,
            providers: [
                {
                    provide: TRANSLOCO_CONFIG,
                    useValue: translocoConfig({
                        availableLangs: availableLocales,
                        defaultLang: defaultLocale,
                        reRenderOnLangChange: true,
                        prodMode: !isDevMode()
                    })
                },
                { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
                { provide: TRANSLOCO_MISSING_HANDLER, useClass: DefaultMissingHandler },
                { provide: TRANSLOCO_INTERCEPTOR, useClass: DefaultInterceptor },
                { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: DefaultFallbackStrategy },
                provideTranslocoMessageformat()
            ]
        };
    }
}
